<p>location-card-detail works!</p>